export default __webpack_public_path__ + "static/media/notes.97d88a68.svg";